module.exports = __webpack_public_path__ + "img/ico-chest-blue-disabled.39dc1cfb.png";